<mat-form-field formGroupName="firstChildGroup" appearance="outline">
  <mat-label>{{labelField}}</mat-label>
  <input [readonly]="isDisabled" matInput type="text" [formControlName]="formControlField" [matAutocomplete]="auto" (keyup)="onKey($event.target.value)" (keydown)="$event.stopPropagation()">
  @if (firstChildGroup.get('firstChildGroup').get(this.formControlField).invalid) {
    <mat-error>Preenchimento incorreto</mat-error>
  }
  <mat-autocomplete #auto="matAutocomplete">
    @for (item of (filteredList | async); track item) {
      <mat-option [value]="item[nameField]" (click)="selectValue(item)">{{item[nameField]}}</mat-option>
    }
  </mat-autocomplete>
</mat-form-field>